import aboutLanding from '@/assets/images/about/about-landing.jpg'
import { Helmet } from 'react-helmet-async'
import { DesignProcess } from '../components/Sections/DesignProcess'
import { Landing } from '../components/Sections/Landing'
import { Teams } from '../components/Sections/Teams'

export const AboutUs = () => {
  return (
    <>
      <Helmet title="About us" />
      <Landing />
      <img
        src={aboutLanding}
        className="size-full max-h-[620px] object-cover"
      />
      <DesignProcess />
      <Teams />
    </>
  )
}
export default AboutUs
